import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
})
export class PrivacyComponent {
  public readonly TRANSLATION_KEYS: string[] = [
    'PRIVACY_POLICY_MAIN_INFORMATION_PART_1',
    'PRIVACY_POLICY_MAIN_INFORMATION_PART_2',
    'PRIVACY_POLICY_MAIN_INFORMATION_PART_3',
    'PRIVACY_POLICY_MAIN_INFORMATION_PART_4',
    'PRIVACY_POLICY_MAIN_INFORMATION_PART_5',
  ];
}
